<template>
  <!-- 青岛出入金相关 -->
  <div id="MyWithdraw">
    <div class="centerContent">
      <div class="leftContent">
        <div class="topTitle">入金</div>
        <div class="textWrap">
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <div class="desc">
                <span class="title">收款方开户行</span>
                <el-input v-model="bankDetails.openBankName" disabled />
                <div class="btnWrap">
                  <p
                    v-clipboard:copy="bankDetails.openBankName"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    aria-hidden="true"
                    class="iconCopy"
                  >复制</p>
                </div>
              </div>
              <div class="desc">
                <span class="title">收款方账号</span>
                <el-input v-model="bankDetails.bankAccount" disabled />
                <div class="btnWrap">
                  <p
                    v-clipboard:copy="bankDetails.bankAccount"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    aria-hidden="true"
                    class="iconCopy"
                  >复制</p>
                </div>
              </div>
              <div class="desc">
                <span class="title">收款方户名</span>
                <el-input v-model="bankDetails.bankAccountName" disabled />
                <div class="btnWrap">
                  <p
                    v-clipboard:copy="bankDetails.bankAccountName"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    aria-hidden="true"
                    class="iconCopy"
                  >复制</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="topTitle">
          <span>出金</span>
          <span class="topBanlance">余额：{{ moreMagin | toThousands }}</span>
        </div>
        <div class="textWrap">
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <div class="desc">
                <span class="tip">温警提示: 出金时间为交易日9:00-20:00(周六9:00-16:00)；初始资金密的123456</span>
              </div>
              <div class="desc">
                <span class="title">出金金额</span>
                <el-input
                  v-model="ruleForm.amount"
                  :placeholder="'可出金额   ' + moreMagin"
                >
                  <template slot="suffix">
                    <span class="iconCopy" @click="getAllMoney" style="color: #999999;">全部</span>
                  </template>
                </el-input>
                <div class="btnWrap">
                </div>
              </div>
              <div class="desc">
                <span class="title">资金密码</span>
                <el-input
                  v-model="ruleForm.password"
                  :type="passType"
                  auto-complete="new-password"
                  placeholder="请输入密码"
                >
                  <template slot="suffix">
                    <img
                      class="eyeStyle"
                      :src="passwordIcon"
                      alt=""
                      @click="changeType"
                    >
                  </template>
                </el-input>
                <div class="btnWrap">
                  <el-button
                    :loading="loading"
                    :disabled="btnDisenable"
                    type="primary"
                    @click="handleSubmit"
                  ><span style="color:#fff">提交</span></el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 出入金流水 -->
    <div class="flow">
      <div class="headerWrap">
        <div class="leftText">出入金流水</div>
      </div>
      <div id="tablePage">
        <el-table
          ref="tableData"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%">
          <template slot="empty">
            <div class="no-datas">
              <div class="no-data-img">
                <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
              </div>
              <div class="no-data">暂无数据</div>
            </div>
          </template>
          <el-table-column align="center" prop="bizName" label="类型">
          </el-table-column>
          <el-table-column align="center" prop="amount" label="发生额">
          </el-table-column>
          <el-table-column prop="occurTime" label="时间">
            <template slot-scope="scope">
              {{ scope.row.occurTime | dateFormate }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="flowId" label="市场流水号">
          </el-table-column>
          <el-table-column align="center" prop="bankFlowId" label="银行流水号">
          </el-table-column>
        </el-table>
        <el-row v-if="pageData.total">
          <el-col :span="24" class="paginateWrap">
            <el-pagination
              popper-class="_popStyle"
              :current-page="pageData.currentPage"
              :page-sizes="pageData.pageSizes"
              :page-size="pageData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol protocolTrans */
import protocol30 from './protocol30'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
// import dialogWithId from '../../../components/base/dialog/dialogWithId.vue'
export default {
  // components: {
  //   dialogWithId
  // },
  data() {
    return {
      loading: false,
      bankId: null,
      passType: 'password',
      passwordIcon: '',
      openImg: require('../../../assets/images/icon/openeye.png'),
      closeImg: require('../../../assets/images/icon/closeeye.png'),
      selectData: '',
      typeCode: null,
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      tableHeight: 0,
      bankDetails: {
        bankAccount: '--',
        bankAccountName: '青岛场外市场清算中心有限公司',
        openBankName: '上海银行',
        openBankNumber: null,
        signFlag: null
      },
      typeFlag: 'text',
      isWithdraw: false,
      /** 银行 */
      banks: [],
      /** 银行 end */
      ruleForm: {
        bankId: '',
        amount: '',
        password: ''
      },
      btnDisenable: false,
      myAccount: {
        accountId: 0,
        avilibleMargin: 0,
        balance: 0,
        createTime: 0,
        currency: '人民币',
        enName: 'CNY',
        firmId: 0,
        frozenFunds: 0,
        lastBalance: 0,
        marketId: 28,
        marketName: '现货买进',
        marketType: '主市场',
        updateTime: 0
      },
      findList: []
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'h_accountTime',
      'marketStatusGetter'
    ]),
    moreMagin() {
      // if (window.g.isSupInfo) { // 硒交项目当日资金不可出  账户资金-冻结资金-出金阈值-当日入金-资金划转差额(负数计算，正数不计算) 划出差额（负数）marketInoutGold 金额 大于入金inGold 时按入金金额计算
      //   if (Number(this.myAccount.marketInoutGold) < 0) {
      //     if (Math.abs(Number(this.myAccount.marketInoutGold)) > Number(this.myAccount.inGold)) {
      //       return this.toZeroThousands(this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.outfundThreshold - this.myAccount.inGold + this.myAccount.inGold)
      //     }
      //     return this.toZeroThousands(this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.outfundThreshold - this.myAccount.inGold - this.myAccount.marketInoutGold)
      //   }
      //   return this.toZeroThousands(this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.outfundThreshold - this.myAccount.inGold)
      // } else {
      //   return this.toZeroThousands(this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.oweMoney - this.myAccount.outfundThreshold)
      // }
      return this.toZeroThousands(this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.oweMoney - this.myAccount.outfundThreshold)
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = document.documentElement.clientHeight - this.$refs.tableData.$el.offsetTop - 32
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = document.documentElement.clientHeight - this.$refs.tableData.$el.offsetTop - 32
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.bankInfo()
    this.searchFirmId1()
    this.param_queryMyIntegralDetail()
    this.passwordIcon = this.closeImg
    this.queryBankName()
  },
  methods: {
    // 查询入金信息
    queryBankName() {
      http.postFront(protocol30.param_queryBankName).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value && value[0]?.bankaccount) {
            console.log('入金信息', value)
            this.bankDetails.bankAccount = value[0]?.banksubaccount
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 查询开户信息 --- 获取签约信息
    bankInfo() {
      http.postFront(protocol.param_findTrader).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.bankId = value.bankId
          }
        } else {
          this.$message(message)
        }
      })
    },
    getAllMoney() {
      this.ruleForm.amount = this.moreMagin
    },
    changeType() {
      this.passType = this.passType == 'password' ? 'text' : 'password'
      this.passwordIcon =
          this.passType == 'password' ? this.closeImg : this.openImg
    },
    onCopy() {
      this.$message('复制成功')
    },
    onError() {
      this.$message('复制失败')
    },
    resetData() {
      this.selectData = ''
      this.typeCode = null
      this.tableData = []
      this.pageData = {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      }
      this.param_queryMyIntegralDetail()
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询出入金流水
    param_queryMyIntegralDetail() {
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.bizCode = null
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.page =
          this.pageData.currentPage - 1
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.size = this.pageData.pageSize
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.sort = [{
        'direction': 'DESC',
        'property': 'flowId'
      }]
      http
        .postFrontChange(
          protocol.param_queryFirmBankAccountInoutFundsFlowFront,
          0
        )
        .then(response => {
          const { code, value, message } = response.data
          if (Number(code) == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            this.tableData = arr
          } else {
            this.$message(message)
          }
        })
    },
    searchFirmId1() {
      const userMes = this.$store.state.common.sessionInfo
      protocolTrans.param_firmIdSearch.param.userId = userMes.userId
      http.postFront(protocolTrans.param_firmIdSearch).then(response => {
        var { value, code, message } = response.data
        if (Number(code) === 0) {
          localStorage.setItem('FirmIdList_w', JSON.stringify(value))
          this.getMyAccount()
        } else {
          this.$message(message)
        }
      })
    },
    // 得到可出金额和上日权益
    getMyAccount() {
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      const firmId = firmList.find(item => {
        return item.marketId === 0
      }).firmId
      const param = JSON.parse(JSON.stringify(protocolTrans.param_mineAsset))
      param.param.firmIds = [firmId]
      http.postFront(param).then((response) => {
        const { code, value, message } = response.data
        if (Number(code) == 0) {
          if (value) {
            this.myAccount = value[0]
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 出金提交
    handleSubmit(name) {
      const reg = /^\d{6}$/
      const regMoney = /^[1-9](\d+)?(\.\d{1,2})?$/
      if (!this.ruleForm.amount) {
        this.$message('请输入出金金额')
        return false
      } else if (!regMoney.test(this.ruleForm.amount)) {
        this.$message('请输入正确的出金金额')
        return false
      } else if (Number(this.ruleForm.amount) > this.moreMagin) {
        this.$message('超出可出金额')
        return false
      } else if (!this.ruleForm.password) {
        this.$message('请输入资金密码')
        return false
      } else if (!reg.test(this.ruleForm.password)) {
        this.$message('请输入正确的资金密码')
        return false
      }
      protocol30.param_marketOutFund_qd.param.pwd = md5(
        '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.ruleForm.password
      )
      protocol30.param_marketOutFund_qd.param.bankId = 30 // 青岛的写死30
      protocol30.param_marketOutFund_qd.param.amount = Number(this.ruleForm.amount)
      protocol30.param_marketOutFund_qd.param.marketId = 0
      protocol30.param_marketOutFund_qd.param.paymentType = 1
      const that = this
      this.btnDisenable = true
      this.loading = true
      http
        .postFrontMarket0(protocol30.param_marketOutFund_qd)
        .then(response => {
          const { code, message } = response.data
          that.btnDisenable = false
          that.loading = false
          if (code === '0' || code === 0) {
            this.$message('提交成功')
            this.ruleForm.password = ''
            this.ruleForm.amount = null
            setTimeout(() => {
              that.getMyAccount()
              that.tableData = []
              that.pageData = {
                total: 0,
                pageSizes: [10, 20, 30, 40],
                pageSize: 20,
                currentPage: 1
              }
              that.param_queryMyIntegralDetail()
            }, 1000)
          } else {
            this.$message(message)
          }
        })
        .catch(response => {
          that.btnDisenable = false
          that.loading = false
        })
    },
    // 资金为负数默认展示0处理千分位
    toZeroThousands(num) {
      if (num && !isNaN(Number(num))) {
        var result = ''
        num = Number(num.toString() || 0).toFixed(2)
        var numAry = num.toString().split('.')
        var preNum = numAry[0]
        var lastNum = numAry[1]
        if (preNum.indexOf('-') !== -1) {
        // 存在-号
          return '0.00'
        } else {
          while (preNum.length > 3) {
            result = ',' + preNum.slice(-3) + result
            preNum = preNum.slice(0, preNum.length - 3)
          }
        }
        if (preNum) {
          result = preNum + result
        }
        result = result + '.' + lastNum
        return result
      } else {
      // // eslint-disable-next-line eqeqeq
      //   if (num == 0) {
        return '0.00'
        // } else {
        //   return num
        // }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
#MyWithdraw {
  .centerContent {
    display: flex;
    margin: 20px 0;
    & > div {
      flex: 1;
    }
    .topTitle {
      padding-bottom: 20px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .topBanlance {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
      }
    }
    .desc {
      font-size: 14px;
      height: 60px;
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      .tip {
        font-family: Source Han Sans SC;
        font-weight: 600;
        font-size: 12px;
        color: #D94066;
      }
      .title {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        width: 20%;
      }
      .el-input {
        width: 50%;
      }
      /deep/ input[type='number'] {
          text-indent: 0;
      }
      /deep/ .el-input__inner {
        height: 30px;
        border: 1px solid #C0C0C0;
      }
      /deep/ .el-input__suffix {
        height: 30px;
        line-height: 30px;
        top: 15px;
        right: 12px;
      }
      .btnWrap {
        width: 30%;
        text-align: left;
        padding-left: 22px;
        .el-button {
          width: 63px;
          height: 30px;
          border-radius: 30px;
          border: 0;
          background: #000;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          padding: 0;
        }
        .iconCopy {
          color: #D94066;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
  .flow {
    .headerWrap {
      height: 48px;
      line-height: 48px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .leftText {
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
    }
  }
  .eyeStyle {
    width: 22px;
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>